import React from "react";
import {
  CreditsContainer,
  ImageWrapper,
  SmallHeading,
  StackedWrapper,
  VideoWrapper,
} from "../styles/components/Galleries/Video";
import ImageDisplay from "./Image";
import Video from "./Video";

const GalleryVideo = ({
  srcs,
  mobile,
  credits = "Fashion Credits",
  videoId,
  wrap = "split",
  reverse = false,
}) => {
  return (
    <StackedWrapper>
      <ImageWrapper>
        <ImageDisplay src={srcs} mobile={mobile} />
        {wrap !== "split" && (
          <CreditsContainer $wrap={wrap}>
            <SmallHeading>{credits}</SmallHeading>
          </CreditsContainer>
        )}
      </ImageWrapper>
      <VideoWrapper $wrap={wrap} $reverse={reverse}>
        <Video videoId={videoId} wrap={wrap} />
        {wrap === "split" && (
          <CreditsContainer $justify="flex-start" $wrap={wrap}>
            <SmallHeading>{credits}</SmallHeading>
          </CreditsContainer>
        )}
      </VideoWrapper>
    </StackedWrapper>
  );
};

export default GalleryVideo;
